import { Map, List } from 'immutable';
import { combineImmutableReducers } from '../../util';
import session_actions from '../../session/actions';
import ACTIONS from '../actions';

const DEFAULT_CLAIM_QUESTIONS = new Map();
const DEFAULT_CLAIM_QUESTIONS_LIST = new List();

function byId(state = DEFAULT_CLAIM_QUESTIONS, action) {
  if (action.type === session_actions.LOGOUT){
    return DEFAULT_CLAIM_QUESTIONS
  }
  if (action.response && action.response.entities && action.response.entities.claim_questions) {
    return state.merge((new Map(action.response.entities.claim_questions)).map(c => new Map(c)));
  }
  return state;
}


// Reducer to keep master list of ids
function ids(state = DEFAULT_CLAIM_QUESTIONS_LIST, action) {
  switch (action.type) {

    case ACTIONS.CODE_LOGIN_FORM_SUCCESS:
    case ACTIONS.LOGIN_FORM_SUCCESS:
      if (action.response && action.response.entities && action.response.entities.claim_questions) {
        return new List(Object.keys(action.response.entities.claim_questions))
      } else {
        return state;
      }
    case session_actions.LOGOUT:
      return DEFAULT_CLAIM_QUESTIONS_LIST
  // case actions.LOAD_ITEMS_SUCCESS:
  //   return new List(action.response.result);
  default:
    return state;
  }
}

// Build our reducer using `combineImmutableReducers`
const reducer = combineImmutableReducers({
  byId,
  ids
});

export default reducer;



// WEBPACK FOOTER //
// ./src/snapit_app/reducers/claim_questions.js